import React, {Component} from 'react';
import ModalWindow from 'shared/components/ModalWindow.jsx';
import Stream from './Stream.jsx';
import {defineMessages, FormattedMessage} from 'react-intl';
import FullscreenImg from '../../../../client/assets/img/fullscreen-btn_img.svg'

const messages = defineMessages({
    playStream: {
        id: 'play.stream.video',
        defaultMessage: 'Доступна прямая трансиляция'
    },
    logInToWatch: {
        id: 'login.to.watch',
        defaultMessage: 'Войдите в систему для просмотра'
    }
});

class StreamPanel extends Component {
    state = {
        showPopUp: false
    };

    closeStreamBlock = () => {
        this.props.stopFetchStreamAction();
    };

    showPopUpHandler = () => {
        this.setState({
            showPopUp: true
        });
    };

    closePopUpHandler = () => {
        this.setState({
            showPopUp: false
        });
    };

    render() {
        const {showPopUp} = this.state;
        const {stream, streamName, user} = this.props;


        const openStream = stream.openStream;
        const streamSrc = stream.src;

        let streamBlockClassName;
        let streamDisplay;
        let streamBlock;

        if (openStream) {
            streamBlockClassName = 'stream-block';
            streamBlock = <Stream src={streamSrc} />;

        } else {
            streamBlockClassName = 'stream-block hidden';
            streamBlock = null;
        }

        if (user !== null && user.get('accountId')) {
            streamDisplay = (
                <div className='stream stream-display'>
                    {streamBlock}
                </div>
            );
        } else {
            streamDisplay = (
                <div className='stream'>
                    <div className='display-inner'>
                        <div>
                            <FormattedMessage {...messages.playStream}/>
                        </div>
                        <p><FormattedMessage {...messages.logInToWatch}/></p>
                    </div>
                </div>
            );
        }

        return (
            <div className={streamBlockClassName}>
                {!showPopUp && <div className='heading'>
                    <button onClick={this.closeStreamBlock} className='close-stream-btn'></button>
                    <span className='stream-team' title={streamName}>{streamName}</span>
                    <button className='full-screen-btn' onClick={this.showPopUpHandler}><img src={FullscreenImg} alt='full-screen'/></button>
                </div>}

                {!showPopUp &&  streamDisplay}

                {showPopUp && <ModalWindow>
                    <div className='modal_stream'>
                        <button onClick={this.closePopUpHandler} className='close-modal-stream' />
                        <Stream src={streamSrc} />
                    </div>
                </ModalWindow>}
            </div>
        )
    }
}

StreamPanel.propTypes = {
    stream: React.PropTypes.object.isRequired,
    streamName: React.PropTypes.any,
    user: React.PropTypes.any,
    stopFetchStreamAction: React.PropTypes.func.isRequired
};

export default StreamPanel;


// WEBPACK FOOTER //
// ./js/sport-betting/components/stream/StreamPanel.jsx